import * as Models from 'contracts/models';

export const Endpoint = (projectId: string) => `/vscanner/api/v2/projects/${projectId}/tasks`;

export const QueryKey = (projectId: string) => ['vscanner', 'api', 'v2', 'projects', projectId, 'tasks'] as const;

export type Payload = Record<string, never>;

export type Response = Models.Vscanner.ProjectTask[];
